/**
 * @wenjuan/business
 * 当前插件的代码在SSR和CSR均会执行，必须注意使用的组件不带有任何浏览器端API
 */
import Vue from 'vue'
import { CommonHeader, CommonFooter } from '@wenjuan/business'

Vue.use(CommonHeader)
Vue.use(CommonFooter)
